module.exports = __webpack_public_path__ + "media/team/UmutKeskin-fdd7582f.webp";